import React, { useEffect, useState } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth"
import 'react-phone-number-input/style.css'

import api from "assets/services/api";


function ModalAddSynthetics(props) {

    const [br, setBR] = useState(false);

    const [code, setCode] = useState();
    const [description, setDescription] = useState();
    const { storageId } = useAuth();
    const [controlSnack, setControlSnack] = useState(false);

    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        if (controlSnack) showNotification("br")
    }, [controlSnack]);

    async function handleAddSynthetic(e) {
        e.preventDefault();
        const response = await api.post('/synthetic', {
            code: code,
            description: description,
            id_admin: storageId,
        });
        if (response.data.error) {
            return alert(response.data.error);
        }
        props.getAllSynthetics();
        props.onHide();
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Adicionar Sintético
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleAddSynthetic}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} xs={2} controlId="formGridName">
                            <Form.Label>Código</Form.Label>
                            <Form.Control onChange={event => setCode(event.target.value)} type="double" placeholder="Código do Sintético" />
                        </Form.Group>
                        <Form.Group as={Col} xs={10} controlId="formGridName">
                            <Form.Label>Descrição</Form.Label>
                            <Form.Control onChange={event => setDescription(event.target.value)} type="text" placeholder="Nome do Sintético" />
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit">
                            Adicionar Sintético
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Sintético adicionado com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalAddSynthetics;